"use strict";
/*
 * Integration App React package
 * {@link https://www.npmjs.com/package/@integration-app/react}
 * v2.21.0
 */
'use client';

import { jsx, jsxs } from 'react/jsx-runtime';
import { forwardRef } from 'react';
import { SvgIconType } from '../../SvgIcon/svg-icon-type.mjs';
import { Formula, Variable, VariableSvgIcon } from '../../Formula/index.mjs';
import { DataBuilderForm } from '../Form.mjs';
import { makeDataField } from '../index.mjs';

const LastNameFormula = forwardRef(
  (props, ref) => {
    return /* @__PURE__ */ jsx(Formula, { ref, onClick: props.onClick, children: /* @__PURE__ */ jsxs(Variable, { children: [
      /* @__PURE__ */ jsx(VariableSvgIcon, { type: SvgIconType.Function }),
      " Extract last name"
    ] }) });
  }
);
LastNameFormula.displayName = "LastNameFormula";
function LastNameFormulaDropdown(props) {
  const { onChange, variablesSchema, optionFactories, formula } = props;
  function handleVariableChange(value) {
    onChange?.({
      $lastName: value
    });
  }
  const valueSchema = {
    title: "Extract last name from",
    type: "string"
  };
  const field = makeDataField({
    schema: valueSchema,
    value: formula.value,
    variablesSchema,
    optionFactories
  });
  return /* @__PURE__ */ jsx(DataBuilderForm, { field, onChange: handleVariableChange });
}

export { LastNameFormulaDropdown, LastNameFormula as default };
